function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-90 376C-60.6158 326.988 -21.2684 327.674 33.6263 308.17C99.9329 284.611 124.048 220.355 97.267 173.532C72.8909 130.913 -28.8893 145.253 0.281989 92.1747C24.8659 47.4435 -61.4675 76.7649 -90 1M-90 242.574C-37.978 265.091 63.2066 281.383 51.769 166.413C43.4979 83.2725 -37.5342 14.3881 -90 77.153",
  stroke: "url(#paint0_linear_7622_149479)",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7622_149479",
  x1: 108,
  y1: 188.5,
  x2: -90,
  y2: 188.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B2FF"
})));

function SvgBlueVectorBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 377,
    viewBox: "0 0 109 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVectorBottom);
export default __webpack_public_path__ + "static/media/BlueVectorBottom.d19afab4def3f44c376ba690098f9480.svg";
export { ForwardRef as ReactComponent };